export const STATUS = {
    LIVE: 'LIVE',
    MULTIPLAYER: 'MULTIPLAYER',
    SCHEDULED: 'SCHEDULED',
    ENDED: 'ENDED',
}
